import { render, staticRenderFns } from "./ActiveExchangeGoods.vue?vue&type=template&id=c2882804&scoped=true"
import script from "./ActiveExchangeGoods.vue?vue&type=script&lang=js"
export * from "./ActiveExchangeGoods.vue?vue&type=script&lang=js"
import style0 from "./ActiveExchangeGoods.vue?vue&type=style&index=0&id=c2882804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2882804",
  null
  
)

export default component.exports